import {
  ON_START_GET_DIALER_USER_HISTORY,ON_GET_DIALER_USER_HISTORY,ON_ERROR_GET_DIALER_USER_HISTORY,
  ON_MESSAGE_KUND,ON_START_FETCH_KUND_BASIC_NOMESSAGE,ON_START_GET_ADS,
  ON_START_UPPDATE_DIALER_KOMMMENTAR, ON_UPPDATE_DIALER_KOMMMENTAR, ON_ERROR_UPPDATE_DIALER_KOMMMENTAR,
  ON_START_FETCH_RAPPORT,ON_FETCH_RAPPORT,ON_ERROR_FETCH_RAPPORT,FETCH_START_SET_UNAUTHE,
  ON_START_GET_DIALER_KOMMUN_LIST,ON_GET_DIALER_KOMMUN_LIST,ON_ERROR_GET_DIALER_KOMMUN_LIST,
  ON_START_GET_DIALER_AVTALSTID_LIST,ON_GET_DIALER_AVTALSTID_LIST,ON_ERROR_GET_DIALER_AVTALSTID_LIST,
    ON_START_FETCH_STATISTIC_KAMPANJER,ON_FETCH_STATISTIC_KAMPANJER,ON_ERROR_FETCH_STATISTIC_KAMPANJER,
    ON_START_FETCH_HIT_COUNT,  ON_FETCH_HIT_COUNT,  ON_ERROR_FETCH_HIT_COUNT,
    ON_START_FETCH_RL_PREPARE,ON_FETCH_RL_PREPARE,ON_ERROR_FETCH_RL_PREPARE,
    ON_START_FETCH_KUND_LIST,ON_FETCH_KUND_LIST,ON_ERROR_FETCH_KUND_LIST,
    ON_START_NEW_RINGLIST,ON_NEW_RINGLIST,ON_ERROR_NEW_RINGLIST,
    ON_START_FETCH_KAMPANJER_ALL,ON_FETCH_KAMPANJER_ALL,ON_ERROR_FETCH_KAMPANJER_ALL,
    ON_START_FETCH_KAMPANJER,ON_FETCH_KAMPANJER,ON_ERROR_FETCH_KAMPANJER,
    ON_START_DELETE_KAMPANJER, ON_DELETE_KAMPANJER, ON_ERROR_DELETE_KAMPANJER,
    ON_START_FETCH_KUND_LISTVY_HR_BYID,ON_FETCH_KUND_LISTVY_HR_BYID,ON_ERROR_FETCH_KUND_LISTVY_HR_BYID,
    ON_START_FETCH_GET_BLACKLIST_LIST,ON_FETCH_GET_BLACKLIST_LIST,ON_ERROR_FETCH_GET_BLACKLIST_LIST,
    ON_START_FETCH_GET_NEXT_KUND, ON_FETCH_GET_NEXT_KUND, ON_ERROR_FETCH_GET_NEXT_KUND,
   // ON_START_FETCH_KUND_LIST_BYID,ON_FETCH_KUND_LIST_BYID,ON_ERROR_FETCH_KUND_LIST_BYID,
    ON_START_FETCH_KAMPANJ_BYID,ON_FETCH_KAMPANJ_BYID,ON_ERROR_FETCH_KAMPANJ_BYID,
    ON_START_UPDATE_RINGLIST,ON_UPDATE_RINGLIST,ON_ERROR_UPDATE_RINGLIST,
    ON_START_FETCH_KUND_LISTVY_BYID,ON_FETCH_KUND_LISTVY_BYID,ON_ERROR_FETCH_KUND_LISTVY_BYID,
    ON_START_FLAG_RINGLIST,ON_FLAG_RINGLIST,ON_ERROR_FLAG_RINGLIST,ON_START_FETCH_KAMPANJ_KUND_PER,
    ON_START_FETCH_KAMPANJ_KUND,ON_FETCH_KAMPANJ_KUND,ON_ERROR_FETCH_KAMPANJ_KUND,ON_SET_ZERO_KAMPANJ_KUND,
    ON_START_KOMMENTAR_RINGLIST,ON_KOMMENTAR_RINGLIST,ON_ERROR_KOMMENTAR_RINGLIST,ON_KOMMENTAR_RINGLIST1,
    ON_START_KAMPANJ_KUND_AKTIV,ON_KAMPANJ_KUND_AKTIV,ON_ERROR_KAMPANJ_KUND_AKTIV,
    ON_START_KAMPANJ_KUND_BOKAMOTE,ON_KAMPANJ_KUND_BOKAMOTE,ON_ERROR_KAMPANJ_KUND_BOKAMOTE,ON_KAMPANJ_KUND_BOKAMOTE_D,
    ON_START_KAMPANJ_KUND_PROSPEKT, ON_KAMPANJ_KUND_PROSPEKT, ON_ERROR_KAMPANJ_KUND_PROSPEKT,
    ON_START_KAMPANJ_KUND_AVTAL, ON_KAMPANJ_KUND_AVTAL, ON_ERROR_KAMPANJ_KUND_AVTAL,
    ON_START_KAMPANJ_KUND_ORDER, ON_KAMPANJ_KUND_ORDER, ON_ERROR_KAMPANJ_KUND_ORDER,
    ON_NEW_ESIGNERING, ON_START_KAMPANJ_KUND_ESIGNERING,ON_ERROR_KAMPANJ_KUND_ESIGNERING,
    ON_START_KAMPANJ_KUND_AKTIVITET, ON_KAMPANJ_KUND_AKTIVITET, ON_ERROR_KAMPANJ_KUND_AKTIVITET,
    ON_START_FETCH_RANDOM_KUND_LIST_BYID,ON_FETCH_RANDOM_KUND_LIST_BYID,ON_ERROR_FETCH_RANDOM_KUND_LIST_BYID,
    ON_START_FETCH_KAMPANJ_MOTE,ON_FETCH_KAMPANJ_MOTE,ON_ERROR_FETCH_KAMPANJ_MOTE,
    ON_START_FETCH_KAMPANJ_PERATERKOMT,ON_FETCH_KAMPANJ_PERATERKOMT,ON_ERROR_FETCH_KAMPANJ_PERATERKOMT,
    ON_START_FETCH_SEARCH_DIALERVYN,ON_FETCH_SEARCH_DIALERVYN,ON_ERROR_FETCH_SEARCH_DIALERVYN,
    ON_START_FETCH_SEARCH_DIALERVYN_1,ON_FETCH_SEARCH_DIALERVYN_NOACCESS,
    ON_START_IMPORT_RINGLIST,ON_IMPORT_RINGLIST,ON_ERROR_IMPORT_RINGLIST,
    ON_START_FETCH_STATISTIC,ON_FETCH_STATISTIC,ON_ERROR_FETCH_STATISTIC,
    ON_START_KAMPANJ_ROMVE_BLIST, ON_KAMPANJ_KUND_ROMVE_BLIST, ON_ERROR_KAMPANJ_KUND_ROMVE_BLIST,
    ON_START_FETCH_GET_KAMPANJER,ON_FETCH_GET_KAMPANJER,ON_ERROR_FETCH_GET_KAMPANJER,
    ON_START_FETCH_GET_BLACKLIST,ON_FETCH_GET_BLACKLIST,ON_ERROR_FETCH_GET_BLACKLIST,
    ON_START_DELETE_FROM_BL, ON_DELETE_FROM_BL, ON_ERROR_DELETE_FROM_BL,
    SET_ZERO_EVENT,ON_FETCH_KAMPANJ_KUND_KOMPANJ,ON_NEW_ORDER,ON_NEW_PROSPEKT,ON_NEW_AVTAL,
    ON_FETCH_KAMPANJ_KUND_KOMPANJ_INNE,ON_FETCH_KAMPANJ_KUND_KOMPANJ_P,
    ON_START_FETCH_GET_NEXT_ORGNR, ON_FETCH_GET_NEXT_ORGNR, ON_ERROR_FETCH_GET_NEXT_ORGNR,
    ON_START_FETCH_GET_PERSONAL_LIST,ON_FETCH_GET_PERSONAL_LIST,ON_ERROR_FETCH_GET_PERSONAL_LIST,
    ON_START_DELETE_FROM_PERSONAL_LIST, ON_DELETE_FROM_PERSONAL_LIST, ON_ERROR_DELETE_FROM_PERSONAL_LIST,
    ON_START_FETCH_KUND_LISTVY_BYID1,ON_ERROR_FETCH_RANDOM_KUND_LIST_BYID_M,ON_SET_NULL_EVENT_DIALER,
    ON_START_FETCH_CHECK_ORGNR_LIST_BYID,ON_FETCH_CHECK_ORGNR_BYID,ON_ERROR_FETCH_CHECK_ORGNR_BYID,
    ON_FETCH_GET_NEXT_KUND_2,ON_FETCH_GET_NEXT_KUND_1,ON_START_FETCH_GET_NEXT_KUND_2,ON_START_FETCH_GET_NEXT_KUND_1,
    ON_START_FETCH_GET_NEXT_ORGNR_1,ON_SET_NULL_MESSAGE_DIALER,ON_SET_NULL_NOACCESS_DIALER,

    ON_START_ADD_KD_DIALER_NEWLINE, ON_ADD_KD_DIALER_NEWLINE, ON_ERROR_ADD_KD_DIALER_NEWLINE,
    ON_START_FETCH_GET_KD_DIALER,ON_FETCH_GET_KD_DIALER,ON_ERROR_FETCH_GET_KD_DIALER,
    ON_UPPDATE_KD_DIALER_NEWLINE, ON_ERROR_UPPDATE_KD_DIALER_NEWLINE,
    ON_DELETE_KD_DIALER_NEWLINE, ON_ERROR_DELETE_KD_DIALER_NEWLINE,

    ON_START_FETCH_GET_RAPPORT_DIALER,ON_ERROR_FETCH_GET_RAPPORT_DIALER,

    ON_OPEN_REFRESH_TOKEN
} from "../constants/ActionTypes";
import axios from 'util/ApiDialer' 
import axios1 from 'util/Api'  
import { history } from "store";
import fileSaver from 'file-saver' 
import { isUndefined,isEmpty } from "lodash";
//import {userSignOut} from 'actions'
import {RefreshUserInterface,getAvtalByID} from 'actions'
import { translate } from "../util/intlHelper";
import {encrypt,decrypt} from 'actions'

const getClientIp = async () => {
  let Ipadress='0.0.0.0'
   /* await fetch('https://geolocation-db.com/json/')
    .then(response => response.json())
    .then(data => {console.log(data)
      Ipadress= data.IPv4});
      */
      return Ipadress
}

//GetHitCountRL
export const GetHitCountRL = (Afid,Ringlist) =>{
    const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
    const ipAdress='0.0.0.0'
      dispatch({type: ON_START_FETCH_HIT_COUNT});      
      axios.get('kontos/RingList/HitCount',
      { params:encrypt(JSON.stringify({Ringlist:Ringlist,Afid:Afid,ipAdress})), 
       headers: { 'Authorization': `Bearer ${jwt}`} }      
       ).then(data => {
        console.log("GetHitCountRL: ", data);
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("GetHitCountRL1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_HIT_COUNT, payload: ndate.results});
       }
       else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("GetHitCountRL2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_FETCH_HIT_COUNT, payload: ndate.error});
       }
      }).catch(function (error) {
        if (error.response.status === 401) {
          dispatch({type: ON_OPEN_REFRESH_TOKEN});
         }
         dispatch({type: ON_ERROR_FETCH_HIT_COUNT, payload: error.message});
         if(error.message === "Network Error"){}
            //reload and remove token  
       });
    }
  }
//PrepareCreateRinglist
export const PrepareCreateRinglist = (Afid) =>{
    const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
        dispatch({type: ON_START_FETCH_RL_PREPARE});
        axios.get('kontos/RingList/Prepare',
        { params:encrypt(JSON.stringify({Afid:Afid})), 
         headers: { 'Authorization': `Bearer ${jwt}`} }      
         ).then(data => {
          if(data.data.success){
             let endata = decrypt(data.data.encryptedData,data.data.iv)
             let ndate = JSON.parse(endata)
             dispatch({type: ON_FETCH_RL_PREPARE, payload: ndate.results});
          }
          else{
            let Data = isUndefined(data.data.error)?data.data:data.data.error
            let endata = decrypt(Data.encryptedData,Data.iv)
            let ndate = JSON.parse(endata)
            dispatch({type: ON_ERROR_FETCH_RL_PREPARE, payload: ndate.error});
          }
         }).catch(function (error) {

           dispatch({type: ON_ERROR_FETCH_RL_PREPARE, payload: error.message});
            console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
         });
      }
}
//GetKundList
export const GetKundList = (Afid,Ringlist,page,RinglistId) =>{
  let Page = isUndefined(page)?0:page
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    
    dispatch({type: ON_START_FETCH_KUND_LIST});
    axios.get('kontos/RingList/KundList',
    { params:encrypt(JSON.stringify({
      Ringlist:Ringlist,
      RinglistId:RinglistId,
      Afid:Afid,
      Page:Page,ipAdress
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(data => {
      console.log("GetKundList: ", data);
      if(data.data.success){
              let endata = decrypt(data.data.encryptedData,data.data.iv)
              console.log("GetKundList: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_FETCH_KUND_LIST, payload: ndate.results});
            }
            else{
              let Data = isUndefined(data.data.error)?data.data:data.data.error
            let endata = decrypt(Data.encryptedData,Data.iv)
              console.log("GetKundList: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_ERROR_FETCH_KUND_LIST, payload: ndate.error});
            }
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_FETCH_KUND_LIST, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
  }
}
//saveThisRinglist
export const saveThisRinglist = (Afid,userid,Ringlista) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_NEW_RINGLIST});
    axios.put('kontos/Ringlist/new', {
     method: 'PUT',
     body: encrypt(JSON.stringify({
       Ringlista:Ringlista,
       Afid:Afid,
       userid:userid,ipAdress
     }))},{
     headers: {
         'content-type': 'application/json',
         'Authorization':   `Bearer ${jwt}`
     }       
 }).then(data => {
  if(data.data.success){
      let endata = decrypt(data.data.encryptedData,data.data.iv)
      console.log("saveThisRinglist: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: ON_NEW_RINGLIST, payload: ndate.results});
    }
    else{
      let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
      console.log("saveThisRinglist: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: ON_ERROR_NEW_RINGLIST, payload: ndate.error});
    }
      dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
      dispatch({type: ON_ERROR_NEW_RINGLIST, payload: error.message});
       console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
    });
  }
}
//exportThisRinglist
export const exportThisRinglist = (Afid,userid,Ringlista) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch,getState) => {
    const {IpAdress} = getState().auth;
    dispatch({type: ON_START_FETCH_RAPPORT});
    axios.get('kontos/Ringlist/export',{
      params:encrypt(JSON.stringify({
       Ringlista:Ringlista,
       Afid:Afid,
       userid:userid,
       ipAdress:IpAdress
      })), 
       responseType: 'arraybuffer' ,
       headers: { 'Authorization': `Bearer ${jwt}`} }
    )
   .then((resp) => {
    if(resp.status === 200){
      const dirtyFileName = resp.headers['content-disposition'];
          const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
          var  fileName = dirtyFileName.match(regex)[3];
          var blob = new Blob([resp.data], 
            { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
          );
          dispatch({type: ON_FETCH_RAPPORT, payload: resp});
          fileSaver.saveAs(blob, fileName);
    }
    else{
      dispatch({type: ON_ERROR_FETCH_RAPPORT, payload: "Error"});
    }
        dispatch(RefreshUserInterface(userid))
       }).catch(function (error) {
         dispatch({type: ON_ERROR_FETCH_RAPPORT, payload: error.message});
         if(!isUndefined(error.response)){
          if (error.response.status === 401) {
            dispatch({type: FETCH_START_SET_UNAUTHE});
           } 
         }
         
         if(error.message === "Network Error"){
            //reload and remove token 
            //dispatch(userSignOut())
         }
       });
  }
}

//getRinglistor
export const getRinglistor = (Afid,userid,page,searchWord,isFrom) =>{
  let Page = isUndefined(page)?0:page
  isFrom = isUndefined(isFrom)?0:isFrom
  searchWord = isUndefined(searchWord)?"":searchWord
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_FETCH_KAMPANJER});
    axios.get('kontos/RingList/Kampanjer',
    { 
      params:encrypt(JSON.stringify({
        userid:userid,
        Afid:Afid,
        Page:Page,
        searchWord:searchWord,ipAdress,isFrom
      })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(data => {
 if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_KAMPANJER, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
      let endata = decrypt(Data.encryptedData,Data.iv)
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_KAMPANJER, payload: ndate.error});
      }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_FETCH_KAMPANJER, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
  }
}
//getRinglistor
export const getRinglistorAll = (Afid,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_FETCH_KAMPANJER_ALL});
    axios.get('kontos/RingList/Kampanjer/all',
    { 
      params:encrypt(JSON.stringify({
        userid:userid,
        Afid:Afid
      })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(data => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_KAMPANJER_ALL, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_FETCH_KAMPANJER_ALL, payload: ndate.error});
      }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_FETCH_KAMPANJER_ALL, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
  }
}
//TEST HÄMTA HELA LISTAN
export const getRinglista = (Afid,userid,page,searchWord) =>{
  let Page = isUndefined(page)?0:page
  searchWord = isUndefined(searchWord)?"":searchWord
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_FETCH_KAMPANJER});
    axios.get('kontos/RingList/Kampanjerss',
    { 
      params:encrypt(JSON.stringify({
        userid:userid,
        Afid:Afid,
        // Page:Page,
        searchWord:searchWord,ipAdress,
      })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(data => {
      if(data.data.success){
              let endata = decrypt(data.data.encryptedData,data.data.iv)
              let ndate = JSON.parse(endata)
              dispatch({type: ON_FETCH_KAMPANJER, payload: ndate.results});
            }
            else{
              let Data = isUndefined(data.data.error)?data.data:data.data.error
            let endata = decrypt(Data.encryptedData,Data.iv)
              let ndate = JSON.parse(endata)
              dispatch({type: ON_ERROR_FETCH_KAMPANJER, payload: ndate.error});
            }
             dispatch(RefreshUserInterface(userid))

     
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_FETCH_KAMPANJER, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
  }
}
//DeleteThisKampanj
export const DeleteThisKampanj = ( Afid,userid,Ringlist) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_DELETE_KAMPANJER});
     axios.delete('kontos/RingList/delete', {
      method: 'DELETE',
      data: encrypt(JSON.stringify({
        userid:userid,
        Afid:Afid,
        Ringlist:Ringlist,ipAdress
      })),
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }  
           
  }).then(data => {
      console.log("DeleteThisKampanj: ", data);
       if(data.data.success){
              let endata = decrypt(data.data.encryptedData,data.data.iv)
              let ndate = JSON.parse(endata)
              dispatch({type: ON_DELETE_KAMPANJER, payload: ndate.results});
            }else{
              let Data = isUndefined(data.data.error)?data.data:data.data.error
            let endata = decrypt(Data.encryptedData,Data.iv)
              let ndate = JSON.parse(endata)
              dispatch({type: ON_ERROR_DELETE_KAMPANJER, payload: ndate.error});
            }
             dispatch(RefreshUserInterface(userid))
   
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_DELETE_KAMPANJER, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
   }
 }
//GetKundHitrate
export const GetKundHitrate = (Afid,userid,Ringlist,Status,searchWord)=>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    let Ringlist2 = {
      Rignlist:Ringlist.Rignlist
    }
    dispatch({type: ON_START_FETCH_KUND_LISTVY_HR_BYID});
    axios.get('kontos/RingList/KundListVyHRById',
    { params:encrypt(JSON.stringify({
      Ringlist:Ringlist2,
      userid:userid,
      Status:Status,
      searchWord:searchWord,
      Afid:Afid
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     )
     .then(data => {
      if(data.data.success){
                let endata = decrypt(data.data.encryptedData,data.data.iv)
                let ndate = JSON.parse(endata)
                console.log(ndate,"GetKundHitrate")
                dispatch({type: ON_FETCH_KUND_LISTVY_HR_BYID, payload: ndate.results});
            }
            else{
              let Data = isUndefined(data.data.error)?data.data:data.data.error
            let endata = decrypt(Data.encryptedData,Data.iv)
              let ndate = JSON.parse(endata)
              dispatch({type: ON_ERROR_FETCH_KUND_LISTVY_HR_BYID, payload: ndate.error});
            }
   
     })
     .catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
      dispatch({type: ON_ERROR_FETCH_KUND_LISTVY_HR_BYID, payload: error.message});
       console.log("Error****:", error.message); 
    });
  }
}
//GetKundListByidListVy
export const GetKundListByidListVy = (Afid,userid,Ringlist,isFrom) =>{
  let IsFrom = isUndefined(isFrom)?0:isFrom
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_KUND_LISTVY_BYID});
  history.push({
    pathname: parseInt(IsFrom) === 0?'/app/Listvy':'/app/Listvy2',
    // pathname:'/app/Listvy' ,
    state: { Ringlist: Ringlist }
  });
  }
}
//GetKundListByid
export const GetKundListByid = (Afid,userid,Ringlist,isFrom,page,searchWord) =>{
  console.log("page",page)
  console.log("GetKundListByid",page)
  let Page = isUndefined(page)?-1:page
  let IsFrom = isUndefined(isFrom)?0:isFrom
  searchWord = isUndefined(searchWord)?"":searchWord
  const jwt =  JSON.parse(localStorage.token);
  console.log(Ringlist)
  let Ringlist2 = {
    Rignlist:Ringlist.Rignlist
  }
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    
    dispatch({type: ON_START_FETCH_KUND_LISTVY_BYID});
    dispatch({type: ON_START_GET_ADS});
    if(Page === 0){
      dispatch(GetKundHitrate(Afid,userid,Ringlist,8,searchWord))
    }
    axios.get('kontos/RingList/KundListVyById',
    { params:encrypt(JSON.stringify({
      Ringlist:Ringlist2,
      userid:userid,
      Afid:Afid,
      Page:Page,
      Status:8,
      searchWord:searchWord,ipAdress
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(data => {
      console.log("GetKundListByid: ", data);
    if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("GetKundListByid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_KUND_LISTVY_BYID, payload: ndate.results});
        history.push({
          pathname: parseInt(IsFrom) === 0?'/app/Listvy':'/app/Listvy2',
          state: { Ringlist: Ringlist }
        });
      }
else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
      let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("GetKundListByid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_FETCH_KUND_LISTVY_BYID, payload: ndate.error});
      }
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_FETCH_KUND_LISTVY_BYID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
  }
}
//getThisListById
export const getThisListById = (Afid,userid,Ringlist) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch,getState) => {
    const ipAdress='0.0.0.0'
    const {Lan} = getState().RingList;
    let Ringlist2 = {
      Rignlist:Ringlist.Rignlist
    }
    dispatch({type: ON_START_FETCH_KAMPANJ_BYID});
    axios.get('kontos/RingList/getById',
    { params:encrypt(JSON.stringify({
      Ringlist:Ringlist2,
      userid:userid,
      Afid:Afid,ipAdress
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(data => {
      console.log("getThisListById: ", data);
      if(data.data.success){ 
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getThisListById1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_KAMPANJ_BYID, payload: ndate.results});
        if(isEmpty(Lan)){
          dispatch(PrepareCreateRinglist(Afid))
          }
        dispatch({type: ON_START_FETCH_HIT_COUNT});
        dispatch({type: ON_FETCH_HIT_COUNT, payload: {message: "getHitCount", HitCount: ndate.results.currentKampanj.hitcount}});
      }
      else{
         let Data = isUndefined(data.data.error)?data.data:data.data.error
              let endata = decrypt(Data.encryptedData,Data.iv)
                console.log("getThisListById2: ", endata);
                let ndate = JSON.parse(endata)
                dispatch({type: ON_ERROR_FETCH_KAMPANJ_BYID, payload: ndate.error});
      }
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_FETCH_KAMPANJ_BYID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
  }
}
//savenewRinglistWithKundData
export const savenewRinglistWithKundData = (Afid,userid,Ringlista) =>{
  const jwt =  JSON.parse(localStorage.token);
  console.log(Ringlista)
  let files = Ringlista.KundDataFile; 
  var fromdata = new FormData();
  fromdata.append("Afid",Afid)
  fromdata.append("userid",userid)
  fromdata.append("Ringlista",JSON.stringify(Ringlista))
  files.forEach(file => fromdata.append('files[]', file));
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_NEW_RINGLIST});
    axios.put('kontos/Ringlist/WithKundData/save', 
    fromdata,
    {
      body:{
       Afid:Afid,
       userid:userid,
       Ringlista:Ringlista,ipAdress
      },
      headers: {
         'Content-Type': 'multipart/form-data',
         'Authorization':   `Bearer ${jwt}`
       }
    }).then(({data}) => {
     console.log("saveThisRinglist: ", data);
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: ON_NEW_RINGLIST, payload: data.results});
      } else {
        dispatch({type: ON_ERROR_NEW_RINGLIST, payload: data.error});
      }
      dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
       if (error.response.status === 401) {
          //place your reentry code
          dispatch({type: ON_OPEN_REFRESH_TOKEN});
         }
      dispatch({type: ON_ERROR_NEW_RINGLIST, payload: error.message});
       console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
    });
  }
}
//savenewRinglist
export const savenewRinglist = (Afid,userid,Ringlista) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_NEW_RINGLIST});
    axios.put('kontos/Ringlist/SaveNew', {
     method: 'PUT',
     body: encrypt(JSON.stringify({
       Ringlista:Ringlista,
       Afid:Afid,
       userid:userid,ipAdress
     }))
    },{
     headers: {
         'content-type': 'application/json',
         'Authorization':   `Bearer ${jwt}`
     }       
 }).then(data => {
     console.log("saveThisRinglist: ", data);
      if(data.data.success){
            let endata = decrypt(data.data.encryptedData,data.data.iv)
            console.log("saveThisRinglist1: ", endata);
            let ndate = JSON.parse(endata)
            dispatch({type: ON_NEW_RINGLIST, payload: ndate.results});
           }
           else{
            let Data = isUndefined(data.data.error)?data.data:data.data.error
            let endata = decrypt(Data.encryptedData,Data.iv)
            console.log("saveThisRinglist2: ", endata);
            let ndate = JSON.parse(endata)
            dispatch({type: ON_ERROR_NEW_RINGLIST, payload: ndate.error});
           }
      dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
      dispatch({type: ON_ERROR_NEW_RINGLIST, payload: error.message});
       console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
    });
  }
}
//UpdateThisRinglist
export const UpdateThisRinglist = (Afid,userid,Ringlista) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_UPDATE_RINGLIST});
    axios.put('kontos/Ringlist/update', {
     method: 'PUT',
     body: encrypt(JSON.stringify({
       Ringlista:Ringlista,
       Afid:Afid,
       userid:userid,ipAdress
     }))
    },{
     headers: {
         'content-type': 'application/json',
         'Authorization':   `Bearer ${jwt}`
     }       
 }).then(data => {
     console.log("UpdateThisRinglist: ", data);
     if(data.data.success){
           let endata = decrypt(data.data.encryptedData,data.data.iv)
           let ndate = JSON.parse(endata)
           console.log("UpdateThisRinglist1: ", ndate);
           dispatch({type: ON_UPDATE_RINGLIST, payload: ndate.results});
          }
          else{
           let Data = isUndefined(data.data.error)?data.data:data.data.error
           let endata = decrypt(Data.encryptedData,Data.iv)
           console.log("UpdateThisRinglist2: ", endata);
           let ndate = JSON.parse(endata)
           dispatch({type: ON_ERROR_UPDATE_RINGLIST, payload: ndate.error});
          }
    }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
      dispatch({type: ON_ERROR_UPDATE_RINGLIST, payload: error.message});
       console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
    });
  }
}
//GetKundListVyByid
export const GetKundListVyByid = (Afid,userid,Ringlist,page,searchWord,Status) =>{
  console.log("page",page)
  console.log("GetKundListVyByid")
  let Page = isUndefined(page)?-1:page
  let status = isUndefined(Status)?0:Status
  searchWord = isUndefined(searchWord)?"":searchWord
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    if(parseInt(Page) <= 0){
      dispatch(GetKundHitrate(Afid,userid,Ringlist,Status,searchWord))
    }
    let Ringlist2 = {
      Rignlist:Ringlist.Rignlist
    }
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_FETCH_KUND_LISTVY_BYID1});
    
    dispatch({type: ON_START_GET_ADS});
    
    axios.get('kontos/RingList/KundListVyById',
    { params:encrypt(JSON.stringify({
      Ringlist:Ringlist2,
      userid:userid,
      Afid:Afid,
      Page:Page,
      Status:status,
      searchWord:searchWord,ipAdress
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(data => {
      console.log("GetKundListVyByid: ", data);
       if(data.data.success){
              let endata = decrypt(data.data.encryptedData,data.data.iv)
              let ndate = JSON.parse(endata)
              console.log("GetKundListVyByid1: ", endata);
              dispatch({type: ON_FETCH_KUND_LISTVY_BYID, payload: ndate.results});
            }
            else{
              let Data = isUndefined(data.data.error)?data.data:data.data.error
            let endata = decrypt(Data.encryptedData,Data.iv)
              let ndate = JSON.parse(endata)
              console.log("GetKundListVyByid2: ", endata);
              dispatch({type: ON_ERROR_FETCH_KUND_LISTVY_BYID, payload: ndate.error});
            }
      
     }).catch(function (error) {
      if (error.response.status === 401) {
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_FETCH_KUND_LISTVY_BYID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
       } 
     });
  }
}
//setFlagRingList
export const setFlagRingList = (Afid,userid,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_FLAG_RINGLIST});
    axios.put('kontos/Ringlist/SetFlag', {
     method: 'PUT',
     body: encrypt(JSON.stringify( {
      Orgnr:Orgnr,
       Afid:Afid,
       userid:userid,ipAdress
     }))
    },{
     headers: {
         'content-type': 'application/json',
         'Authorization':   `Bearer ${jwt}`
     }       
 }).then(data => {
   console.log("setFlagRingList: ", data);
       if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        let ndate = JSON.parse(endata)
        console.log("setFlagRingList1: ", endata);
        dispatch({type: ON_FLAG_RINGLIST, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("setFlagRingList2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_FLAG_RINGLIST, payload: ndate.error});
      }
        dispatch(RefreshUserInterface(userid))

    }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
      dispatch({type: ON_ERROR_FLAG_RINGLIST, payload: error.message});
       console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
    });
  }
}
//setZeroThisKampnajKundItem
export const setZeroThisKampnajKundItem = () =>{
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_SET_ZERO_KAMPANJ_KUND});
  }
}
//getThisKampnajKundItem
export const getThisKampnajKundItem = (Afid,userid,Orgnr,ListID,filter) =>{
  const ListId = isUndefined(ListID)?0:ListID
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_FETCH_KAMPANJ_KUND});
    dispatch({type: SET_ZERO_EVENT});
    axios.get('kontos/RingList/getKund',
    { params:encrypt(JSON.stringify({
      Orgnr:Orgnr,
      userid:userid,
      Afid:Afid,ipAdress,ListId
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(data => {
      console.log("getThisKampnajKundItem: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getThisKampnajKundItem1: ", endata);
        let ndate = JSON.parse(endata)
          if(ListID !== 0){
            dispatch(getNextKund(Afid,userid,Orgnr,ListID,filter))
          }
          if(isUndefined(ndate.results.noAccess)){          
                    dispatch({type: ON_FETCH_KAMPANJ_KUND, payload: ndate.results});
                  }else{
                    dispatch({type: ON_FETCH_SEARCH_DIALERVYN_NOACCESS, payload: ndate.results});
                  }
        
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getThisKampnajKundItem2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_FETCH_KAMPANJ_KUND, payload: ndate.error});
      }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_FETCH_KAMPANJ_KUND, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
       } 
     });
  }
}
//JACK
export const onSaveKampanjKundKontakter = (Afid, userid, Orgnr, Kontakt) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    axios.put('kontos/Ringlist/SetKontakt', {
     method: 'PUT',
     body: encrypt(JSON.stringify({
      Orgnr:Orgnr,
       Afid:Afid,
       Kontakt:Kontakt,
       userid:userid
     }))
    },{
     headers: {
         'content-type': 'application/json',
         'Authorization':   `Bearer ${jwt}`
     }       
 }).then(data => {
     console.log("onSaveKampanjKundKontakter: ", data);
     
    }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
      dispatch({type: ON_ERROR_KOMMENTAR_RINGLIST, payload: error.message});
       console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
    });
  }
}
//onSaveKampanjKundKommentar
export const onSaveKampanjKundKommentar = (Afid, userid, Orgnr, Kommentar,ListID) =>{
  const ListId = isUndefined(ListID)?0:ListID
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_KOMMENTAR_RINGLIST});
    axios.put('kontos/Ringlist/SetKommentar', {
     method: 'PUT',
     body: encrypt(JSON.stringify({
      Orgnr:Orgnr,
       Afid:Afid,
       Kommentar:Kommentar,
       userid:userid,ipAdress,ListId
     }))
    },{
     headers: {
         'content-type': 'application/json',
         'Authorization':   `Bearer ${jwt}`
     }       
 }).then(data => {
     console.log("onSaveKampanjKundKommentar: ", data);
      if(data.data.success){
           let endata = decrypt(data.data.encryptedData,data.data.iv)
           let ndate = JSON.parse(endata)
           console.log("onSaveKampanjKundKommentar1: ", endata);
           dispatch({type: ON_KOMMENTAR_RINGLIST, payload: ndate.results});
         }
         else{
           let Data = isUndefined(data.data.error)?data.data:data.data.error
           let endata = decrypt(Data.encryptedData,Data.iv)
           console.log("onSaveKampanjKundKommentar2: ", endata);
           let ndate = JSON.parse(endata)
           dispatch({type: ON_ERROR_KOMMENTAR_RINGLIST, payload: ndate.error});
         }
     
      dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
      dispatch({type: ON_ERROR_KOMMENTAR_RINGLIST, payload: error.message});
       console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
    });
  }
}
//onSaveKampanjKundStatus
export const onSaveKampanjKundStatus = (Afid, userid, Orgnr, Status,isFrom,isAPerRecall,RinglistaId,filter) =>{
  const jwt =  JSON.parse(localStorage.token);
  let RinglistaID = isUndefined(RinglistaId)?0:RinglistaId
  return async (dispatch,getState) => {
    const {NextOrgnrList} = getState().RingList;
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_KOMMENTAR_RINGLIST});
    axios.put('kontos/Ringlist/SetStatus', {
     method: 'PUT',
     body: encrypt(JSON.stringify({
      Orgnr:Orgnr,
      Afid:Afid,
      Status:Status,
      isFrom:isFrom,
      userid:userid,ipAdress,
      RinglistaId:RinglistaID,
      isAPerRecall
     }))
    },{
     headers: {
         'content-type': 'application/json',
         'Authorization':   `Bearer ${jwt}`
     }       
 }).then(data => {
     console.log("onSaveKampanjKundStatus: ", data);
       if(data.data.success){
           if(parseInt(isFrom) === 0){
             let GetNext = 0
             if(parseInt(Status.Type) > 1){
               GetNext=1
             }
             let GOrgnr = GetNext === 1?isEmpty(String(NextOrgnrList))?Orgnr:NextOrgnrList:Orgnr
             dispatch(getThisKampnajKundItem(Afid,userid,GOrgnr,RinglistaId,filter))
            }
            else{
           let endata = decrypt(data.data.encryptedData,data.data.iv)
           console.log("onSaveKampanjKundStatus1: ", endata);
           let ndate = JSON.parse(endata)
           if(RinglistaID === 0){
             dispatch(searchInDialerVyn1(Afid,userid,Orgnr))
           }
           dispatch({type: ON_KOMMENTAR_RINGLIST, payload: ndate.results});
            }
         }
         else{
           let Data = isUndefined(data.data.error)?data.data:data.data.error
       let endata = decrypt(Data.encryptedData,Data.iv)
           console.log("onSaveKampanjKundStatus2: ", endata);
           let ndate = JSON.parse(endata)
           dispatch({type: ON_ERROR_KOMMENTAR_RINGLIST, payload: ndate.error});
          }
      dispatch(GetMinaPerAterkomtKampanj(Afid,userid))
      dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
      dispatch({type: ON_ERROR_KOMMENTAR_RINGLIST, payload: error.message});
       console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
    });
  }
}
//ActiveKundByOrgnrRL
export const ActiveKundByOrgnrRL = (Orgnr, Afid, userid,Kontakt,DialerKommentar,Dialer,RinglistaId) =>{
  const jwt =  JSON.parse(localStorage.token);
  let dialer = isUndefined(Dialer)?0:Dialer
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_KAMPANJ_KUND_AKTIV});
    axios.put('kontos/Ringlist/Kund/Aktiva', {
     method: 'PUT',
     body: encrypt(JSON.stringify({
        Orgnr:Orgnr,
        Afid:Afid,
        Kontakt:Kontakt,
        DialerKommentar:DialerKommentar,
        userid:userid,ipAdress,RinglistaId
     }))
    },{
     headers: {
         'content-type': 'application/json',
         'Authorization':   `Bearer ${jwt}`
     }       
 }).then(data => {
     console.log("ActiveKundByOrgnr: ", data);
     if(data.data.success){
           let endata = decrypt(data.data.encryptedData,data.data.iv)
           console.log("ActiveKundByOrgnr1: ", endata);
           let ndate = JSON.parse(endata)
           if(dialer  === 1){
           }else{      
           dispatch({type: ON_KAMPANJ_KUND_AKTIV, payload: ndate.results});
           }
           dispatch({type: ON_START_FETCH_KUND_BASIC_NOMESSAGE, payload: ndate.results});  
           history.push({
             pathname: '/app/Kund',
             state: { Orgnr: Orgnr}
           })
         }
         else{
           let Data = isUndefined(data.data.error)?data.data:data.data.error
           let endata = decrypt(Data.encryptedData,Data.iv)
           console.log("ActiveKundByOrgnr2: ", endata);
           let ndate = JSON.parse(endata)
           dispatch({type: ON_ERROR_KAMPANJ_KUND_AKTIV, payload: ndate.error});
         }         
           dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
      dispatch({type: ON_ERROR_KAMPANJ_KUND_AKTIV, payload: error.message});
       console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
    });
  }
}
//createNewEventRL
export const createNewEventRL = (userid,AFid,NEvent,DialerKommentar,Dialer,RinglistaId) =>{
  let dialer = isUndefined(Dialer)?0:Dialer
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    let files = isEmpty(NEvent.Event.Files)?[]:NEvent.Event.Files; 
    delete NEvent.Event.Files;
    var fromdata = new FormData();
    fromdata.append("Afid",AFid)
    fromdata.append("DialerKommentar",DialerKommentar)
    fromdata.append("Dialer",Dialer)
    fromdata.append("RinglistaId",RinglistaId)
    fromdata.append("userid",userid)
    fromdata.append("ipAdress",ipAdress)
    fromdata.append("Event",JSON.stringify(NEvent))
    for(let file of files){
      fromdata.append('files[]', file)
    }
    dispatch({type: ON_START_KAMPANJ_KUND_BOKAMOTE});
   
    axios1.post('kontos/Ringlist/Kund/BokaMote', 
    fromdata,
    {
      body:{
        NEvent:JSON.stringify(NEvent),
        DialerKommentar:DialerKommentar,
        Afid:AFid,
        userid:userid,ipAdress,RinglistaId
      },
      headers: {
         'Content-Type': 'multipart/form-data',
         'Authorization':   `Bearer ${jwt}`
       }
    }    
).then(({data}) => {
     console.log("createNewEventRL: ", data);
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
       if(dialer  === 1){
        dispatch({type: ON_KAMPANJ_KUND_BOKAMOTE_D, payload: data.results});
      }else{
        dispatch({type: ON_KAMPANJ_KUND_BOKAMOTE, payload: data.results});
      }     
      dispatch(GetMinaPerAterkomtKampanj(AFid,userid))
      dispatch(GetMinaMoteKampanj(AFid,userid))
      } else {
        dispatch({type: ON_ERROR_KAMPANJ_KUND_BOKAMOTE, payload: data.error});
      }
      
     // dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
      dispatch({type: ON_ERROR_KAMPANJ_KUND_BOKAMOTE, payload: error.message});
       console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
    });
  }
}
//createNewProspektRL
export const createNewProspektRL = (userid,Afid,Navtal,DialerKommentar,Dialer,RinglistaId) =>{
  const jwt =  JSON.parse(localStorage.token);
  let dialer = isUndefined(Dialer)?0:Dialer
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_KAMPANJ_KUND_PROSPEKT});
     axios.put('kontos/Ringlist/Kund/Prospekt', {
      method: 'PUT',
      body: encrypt(JSON.stringify({
        Avtal:Navtal,
        Afid:Afid,
        DialerKommentar:DialerKommentar,
        userid:userid,ipAdress,RinglistaId
      }))
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(data => {
      console.log("createNewProspektRL: ", data);
       if(data.data.success){
              let endata = decrypt(data.data.encryptedData,data.data.iv)
                console.log("GetHitCountRL1: ", endata);
                let ndate = JSON.parse(endata)
          dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.Create.Prospect",`Prospekt #19${ndate.results.Avtal.Avtal[0].id} har skapats`,{AvtalId:ndate.results.Avtal.Avtal[0].id})});
             
              dispatch(getAvtalByID(ndate.results.Avtal.Avtal[0].Orgnr,Afid,userid,ndate.results.Avtal.Avtal[0].id))
            }
            else{
              let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
              console.log("createNewProspektRL2: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_ERROR_KAMPANJ_KUND_PROSPEKT, payload: ndate.error});
            } 
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_KAMPANJ_KUND_PROSPEKT, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
   }
 } 
//CreateEsigneringRL
export const CreateEsigneringRL = (Afid,userid,newEsignering,DialerKommentar,Dialer,RinglistaId) =>{
  const jwt =  JSON.parse(localStorage.token);
  let dialer = isUndefined(Dialer)?0:Dialer
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    let files = isEmpty(newEsignering.Document.file)?[]:newEsignering.Document.file; 
    console.log(files)
    
    var fromdata = new FormData();
    fromdata.append("Afid",Afid)
    fromdata.append("userid",userid)
    fromdata.append("ipAdress",ipAdress)
    fromdata.append("NewSignering",JSON.stringify(newEsignering))
    fromdata.append("DialerKommentar",DialerKommentar)
    fromdata.append("RinglistaId",RinglistaId)
    files.forEach(file => fromdata.append('files[]', file));
    dispatch({type: ON_START_KAMPANJ_KUND_ESIGNERING});
    axios.post('kontos/Ringlist/Kund/Esignering',
    fromdata,
    {
      body: {
        newEsignering:newEsignering,
        Afid:Afid,
        DialerKommentar:DialerKommentar,
        userid:userid,ipAdress,RinglistaId
      },
      headers: {
        'content-type': 'multipart/form-data',
        'Authorization':   `Bearer ${jwt}`
    }            
    }).then(({data}) => {
      console.log("CreateEsigneringRL: ", data);
       if (data.results) {
        dispatch({type: ON_NEW_ESIGNERING, payload: data.results});
        history.push({
          pathname: '/app/EsigneringKort',
          state: { Esignering: data.results.CurrentEsignering}
        });
       
       } else {
         dispatch({type: ON_ERROR_KAMPANJ_KUND_ESIGNERING, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_KAMPANJ_KUND_ESIGNERING, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
   }
 } 
//createNewAvtalRL
export const createNewAvtalRL = (userid,Afid,Navtal,DialerKommentar,Dialer,RinglistaId) =>{
  const jwt =  JSON.parse(localStorage.token);
  let dialer = isUndefined(Dialer)?0:Dialer
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_KAMPANJ_KUND_AVTAL});
     axios.put('kontos/Ringlist/Kund/Avtal', {
      method: 'PUT',
      body: encrypt(JSON.stringify({
        Avtal:Navtal,
        Afid:Afid,
        DialerKommentar:DialerKommentar,
        userid:userid,ipAdress,RinglistaId
      }))
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(data => {
console.log("createNewAvtalRL: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("createNewAvtalRL1: ", endata);
          let ndate = JSON.parse(endata)
        dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.Create.Cointract",`Avtal #19${ndate.results.Avtal.Avtal[0].id} har skapats`,{AvtalId:ndate.results.Avtal.Avtal[0].id})});
        dispatch(getAvtalByID(ndate.results.Avtal.Avtal[0].Orgnr,Afid,userid,ndate.results.Avtal.Avtal[0].id))
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
    let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("createNewAvtalRL2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_KAMPANJ_KUND_AVTAL, payload: ndate.error});
      } 
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_KAMPANJ_KUND_AVTAL, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
   }
} 
//saveThisNewOrderRL
export const saveThisNewOrderRL = (Orgnr, Afid, userid,norder,DialerKommentar,Dialer,RinglistaId) =>{
  let dialer = isUndefined(Dialer)?0:Dialer
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_KAMPANJ_KUND_ORDER});
     axios.put('kontos/Ringlist/Kund/Order', {
      method: 'PUT',
      body: encrypt(JSON.stringify({
        Order:norder,
        Orgnr:Orgnr,
        DialerKommentar:DialerKommentar,
        Afid:Afid,
        userid:userid,ipAdress,RinglistaId
      }))
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(data => {
      console.log("saveThisNewOrderRL: ", data);
 if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("saveThisNewOrderRL1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_NEW_ORDER, payload: ndate.results});
          history.push({
            pathname: '/app/Orderkort',
            state: { OrderId: ndate.results.Order.Order[0] }
          });
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("saveThisNewOrderRL2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_KAMPANJ_KUND_ORDER, payload: ndate.error});
      }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_KAMPANJ_KUND_ORDER, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
   }
 } 
//createNewAktivitetRL
export const createNewAktivitetRL = (userid,Afid,nAktivitet,DialerKommentar,Dialer,Status,RinglistaId) =>{
  const jwt =  JSON.parse(localStorage.token);
  let dialer = isUndefined(Dialer)?0:Dialer
  console.log(dialer)
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_KAMPANJ_KUND_AKTIVITET});
     axios.put('kontos/Ringlist/Kund/Aktivitet', {
      method: 'PUT',
      body: encrypt(JSON.stringify({
        Aktivitet:nAktivitet,
        Afid:Afid,
        Status:Status,
        DialerKommentar:DialerKommentar,
        userid:userid,ipAdress,RinglistaId
      }))
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(data => {
      console.log("createNewAktivitetRL: ", data);
if(data.data.success){
        if(dialer  === 1){
        }else{
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("createNewAktivitetRL1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_KAMPANJ_KUND_AKTIVITET, payload: ndate.results});
        }
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("createNewAktivitetRL2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_KAMPANJ_KUND_AKTIVITET, payload: ndate.error});
      }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_KAMPANJ_KUND_AKTIVITET, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
   }
 } 
 //getNextKund
 export const getNextKund = (Afid,userid,Orgnr,ListID,filter) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_FETCH_GET_NEXT_KUND});
    axios.get('kontos/RingList/getNextKund',
    { params:encrypt(JSON.stringify({
      userid:userid,ipAdress,
      Afid:Afid,
      ListID:ListID,
      Orgnr:Orgnr,filter
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(data => {
      console.log("getNextKund: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getNextKund1: ", endata);
        let ndate = JSON.parse(endata)
        if(isUndefined(ndate.results.noAccess)){
          dispatch({type: ON_FETCH_GET_NEXT_KUND, payload: ndate.results});  
        }else{
          let NextOrgnr =ndate.results.NextOrgnr
          if(!isEmpty(String(NextOrgnr))){
            dispatch(getNextKund(Afid,userid,NextOrgnr,ListID,filter))
          }
        }
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getNextKund2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_FETCH_GET_NEXT_KUND, payload: ndate.error});
      }
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_FETCH_GET_NEXT_KUND, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
  }
 }
//getThisKampnajKundItemNext

//getNextOrgnr
export const getNextOrgnrBuffer = (Afid,userid,Ringlist,BufferedOrgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch,getState) => {
    const {RequestIsSend} = getState().RingList;
    console.log(RequestIsSend,"RequestIsSend")
    if(parseInt(RequestIsSend) === 0){
    const ipAdress='0.0.0.0'
    if(!isEmpty(BufferedOrgnr)){
    dispatch({type: ON_START_FETCH_GET_NEXT_ORGNR});
    }else{
      dispatch({type: ON_START_FETCH_GET_NEXT_ORGNR_1});
    }
    let Ringlist2 = {
      Rignlist:Ringlist.Rignlist
    }
    axios.get('kontos/RingList/getNextOrgnr',
    { params:encrypt(JSON.stringify({
      userid:userid,ipAdress,
      Afid:Afid,
      Ringlist:Ringlist2,
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(data => {
      console.log("GetMinaMoteKampanj: ", data);
       if(data.data.success){
              let endata = decrypt(data.data.encryptedData,data.data.iv)
              console.log("getNextOrgnrBuffer1: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_FETCH_GET_NEXT_ORGNR, payload: ndate.results});
            }
            else{
              let Data = isUndefined(data.data.error)?data.data:data.data.error
              let endata = decrypt(Data.encryptedData,Data.iv)
              console.log("getNextOrgnrBuffer2: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_ERROR_FETCH_GET_NEXT_ORGNR, payload: ndate.error});
            }
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_FETCH_GET_NEXT_ORGNR, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
  }
}
 }
 
 //GetRandomKundListByid
 export const GetRandomKundListByid = (Afid,userid,Ringlist,page,BufferedOrgnr,IsFrom) =>{
  const jwt =  JSON.parse(localStorage.token);
  let  isFrom = isUndefined(IsFrom)?0:IsFrom
  //const RequestIsSend=0
  console.log(BufferedOrgnr,"DDDdsDDD")
  return async (dispatch,getState) => {
    const {RequestIsSend} = getState().RingList;
    console.log(RequestIsSend,"RequestIsSend")
    if(parseInt(RequestIsSend) === 0){
    const ipAdress='0.0.0.0'
    if(!isEmpty(BufferedOrgnr)){
      dispatch({type: ON_START_FETCH_GET_NEXT_ORGNR});
    }
    dispatch({type: SET_ZERO_EVENT});
    if(page === 0){        
        history.push({
            // pathname: '/app/Dialervy',
            pathname: parseInt(isFrom) === 0?'/app/Dialervy2':'/app/Dialervy2',
            state: { Ringlist: Ringlist }
          });
          dispatch({type: ON_START_FETCH_RANDOM_KUND_LIST_BYID});
          let Ringlist2 = {
            Rignlist:Ringlist.Rignlist
          }
            axios.get('kontos/RingList/RandomKund',
            { params:encrypt(JSON.stringify({
              Ringlist:Ringlist2,
              userid:userid,
              Afid:Afid,
              BufferedOrgnr:BufferedOrgnr,ipAdress
            })), 
             headers: { 'Authorization': `Bearer ${jwt}`} }      
             ).then(data => {
if(data.data.success){
                let endata = decrypt(data.data.encryptedData,data.data.iv)
                let ndate = JSON.parse(endata)
                //currentKampanjKund
                if(parseInt(ndate.results.userid) === parseInt(userid)  || isEmpty( ndate.results.currentKampanjKund )){
                  dispatch({type: ON_FETCH_RANDOM_KUND_LIST_BYID, payload: ndate.results});
                  dispatch(getNextOrgnrBuffer(Afid,userid,Ringlist,BufferedOrgnr))
                }
                else{
                  dispatch(GetRandomKundListByid(Afid,userid,Ringlist,page,BufferedOrgnr,IsFrom))
                }
              }
              else{
                let Data = isUndefined(data.data.error)?data.data:data.data.error
                let endata = decrypt(Data.encryptedData,Data.iv)
                console.log("GetRandomKundListByid111112: ", endata);
                let ndate = JSON.parse(endata)
                dispatch({type: ON_ERROR_FETCH_RANDOM_KUND_LIST_BYID, payload: ndate.error});
              } 
               dispatch(RefreshUserInterface(userid))
             }).catch(function (error) {
              if (error.response.status === 401) {
                //place your reentry code
                dispatch({type: ON_OPEN_REFRESH_TOKEN});
               }
               dispatch({type: ON_ERROR_FETCH_RANDOM_KUND_LIST_BYID_M, payload: error.message});
                console.log("Error****:", error.message); 
               if(error.message === "Network Error"){
                  //reload and remove token 
                 // ////dispatch(userSignOut())
               } 
             });
        }
        else{
          if(BufferedOrgnr === "Kampajen är slut"){
            dispatch({type: ON_FETCH_RANDOM_KUND_LIST_BYID, payload: {currentKampanjKund:{},message:translate("Callinglist.isFinished"),kanPersonligaAterkost:0}});
          }
          else if(isEmpty(BufferedOrgnr)){
            let Ringlist2 = {
              Rignlist:Ringlist.Rignlist
            }
            dispatch({type: ON_START_FETCH_RANDOM_KUND_LIST_BYID});
            axios.get('kontos/RingList/RandomKund',
            { params:encrypt(JSON.stringify({
              Ringlist:Ringlist2,
              userid:userid,
              Afid:Afid,
              BufferedOrgnr:BufferedOrgnr,ipAdress
            })), 
             headers: { 'Authorization': `Bearer ${jwt}`} }      
             ).then(data => {
console.log("GetRandomKundListByid11112: ", data);
              if(data.data.success){
                let endata = decrypt(data.data.encryptedData,data.data.iv)
                console.log("GetRandomKundListByid111121: ", endata);
                let ndate = JSON.parse(endata)
                if(parseInt(ndate.results.userid) === parseInt(userid) || isEmpty(ndate.results.currentKampanjKund)){
                  dispatch({type: ON_FETCH_RANDOM_KUND_LIST_BYID, payload: ndate.results});
                //  if(!isEmpty(BufferedOrgnr)){
                    dispatch(getNextOrgnrBuffer(Afid,userid,Ringlist,BufferedOrgnr))
                  }else{
                    dispatch(GetRandomKundListByid(Afid,userid,Ringlist,page,BufferedOrgnr,IsFrom))
                  }
              }
              else{
                let Data = isUndefined(data.data.error)?data.data:data.data.error
                let endata = decrypt(Data.encryptedData,Data.iv)
                console.log("GetRandomKundListByid111122: ", endata);
                let ndate = JSON.parse(endata)
                dispatch({type: ON_ERROR_FETCH_RANDOM_KUND_LIST_BYID, payload: ndate.error});
              }
               dispatch(RefreshUserInterface(userid))
             }).catch(function (error) {
              if (error.response.status === 401) {
                //place your reentry code
                dispatch({type: ON_OPEN_REFRESH_TOKEN});
               }
               dispatch({type: ON_ERROR_FETCH_RANDOM_KUND_LIST_BYID_M, payload: error.message});
                console.log("Error****:", error.message); 
               if(error.message === "Network Error"){
                  //reload and remove token 
                 // ////dispatch(userSignOut())
               } 
             });

          }
          else{
            let Ringlist2 = {
              Rignlist:Ringlist.Rignlist
            }
            dispatch({type: ON_START_FETCH_CHECK_ORGNR_LIST_BYID});
            axios.get('kontos/RingList/checkORgnr',
            { params:encrypt(JSON.stringify({
              Ringlist:Ringlist2,
              userid:userid,
              Afid:Afid,
              BufferedOrgnr:BufferedOrgnr,ipAdress
            })), 
             headers: { 'Authorization': `Bearer ${jwt}`} }      
             ).then(data => {
 console.log("GetRandomKundListByid: ", data);
              if(data.data.success){
                let endata = decrypt(data.data.encryptedData,data.data.iv)
                console.log("GetRandomKundListByid1: ", endata);
                let ndate = JSON.parse(endata)
                dispatch({type: ON_FETCH_CHECK_ORGNR_BYID, payload: ndate.results});
                dispatch(getNextOrgnrBuffer(Afid,userid,Ringlist,BufferedOrgnr))
              }
              else{
                let Data = isUndefined(data.data.error)?data.data:data.data.error
                let endata = decrypt(Data.encryptedData,Data.iv)
                console.log("GetRandomKundListByid2: ", endata);
                let ndate = JSON.parse(endata)
                dispatch({type: ON_ERROR_FETCH_CHECK_ORGNR_BYID, payload: ndate.error});
              }    
              dispatch(RefreshUserInterface(userid))
            }).catch(function (error) {
              if (error.response.status === 401) {
                //place your reentry code
                dispatch({type: ON_OPEN_REFRESH_TOKEN});
               }
              dispatch({type: ON_ERROR_FETCH_RANDOM_KUND_LIST_BYID_M, payload: error.message});
               console.log("Error****:", error.message); 
              if(error.message === "Network Error"){
                 //reload and remove token 
                // ////dispatch(userSignOut())
              } 
            });
          }
         
    }
  }
}
}

//GetMinaMoteKampanj
export const GetMinaMoteKampanj = (Afid,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_FETCH_KAMPANJ_MOTE});
    axios.get('kontos/RingList/getMote',
    { params:encrypt(JSON.stringify({
      userid:userid,
      Afid:Afid,ipAdress
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(data => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("GetMinaMoteKampanj1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_KAMPANJ_MOTE, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("GetMinaMoteKampanj2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_FETCH_KAMPANJ_MOTE, payload: ndate.error});
      }    
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_FETCH_KAMPANJ_MOTE, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
  }
}
//GetMinaPerAterkomtKampanj
export const GetMinaPerAterkomtKampanj = (Afid,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_FETCH_KAMPANJ_PERATERKOMT});
    axios.get('kontos/RingList/getPersonAterkomst',
    { params:encrypt(JSON.stringify({
      userid:userid,
      Afid:Afid,ipAdress
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
 console.log("GetMinaPerAterkomtKampanj: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("GetMinaPerAterkomtKampanj1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_KAMPANJ_PERATERKOMT, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("GetMinaPerAterkomtKampanj2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_FETCH_KAMPANJ_PERATERKOMT, payload: ndate.error});
      }   
     }).catch(function (error) {
     
       dispatch({type: ON_ERROR_FETCH_KAMPANJ_PERATERKOMT, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
  }
}
//searchInDialerVyn
export const searchInDialerVyn = (Afid,userid,searchWord,Ringlist) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch,getState) => {
    const {NextOrgnr} = getState().RingList;
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_FETCH_SEARCH_DIALERVYN});
    axios.get('kontos/RingList/Dialer/searchFor',
    { params:encrypt(JSON.stringify({
      userid:userid,
      searchWord:searchWord,
      Afid:Afid,ipAdress
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("searchInDialerVyn: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("searchInDialerVyn1: ", endata);
        let ndate = JSON.parse(endata)
        console.log("searchInDialerVyn1: ", ndate);
        if(isUndefined(ndate.results.noAccess)){
        if(!isEmpty(Ringlist)){
          if(isEmpty(NextOrgnr)){
            let kampanj = {Rignlist:{id:Ringlist.Kampnaj.id}}
            dispatch(getNextOrgnrBuffer(Afid,userid,kampanj,searchWord))
          }
        }
        dispatch({type: ON_FETCH_SEARCH_DIALERVYN, payload: ndate.results});
        }else{
        dispatch({type: ON_FETCH_SEARCH_DIALERVYN_NOACCESS, payload: ndate.results});
        }
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("searchInDialerVyn2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_SEARCH_DIALERVYN, payload: ndate.error});
      }
      // dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_FETCH_SEARCH_DIALERVYN, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
  }
}
export const searchInDialerVyn1 = (Afid,userid,searchWord) =>{

  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch,getState) => {
    const {NextOrgnr} = getState().RingList;
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_FETCH_SEARCH_DIALERVYN_1});
    axios.get('kontos/RingList/Dialer/searchFor',
    { params:encrypt(JSON.stringify({
      userid:userid,
      searchWord:searchWord,
      Afid:Afid,ipAdress
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(data => {
      console.log("searchInDialerVyn: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("searchInDialerVyn1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_SEARCH_DIALERVYN, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("searchInDialerVyn12: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_SEARCH_DIALERVYN, payload: ndate.error});
      }

      // dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      if (error.response.status === 401) {
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_FETCH_SEARCH_DIALERVYN, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
       } 
     });
  }
}
//ImportRinglist
export const ImportRinglist =(Afid,userid,Ringlista)=>{
  const jwt =  JSON.parse(localStorage.token);
  console.log(Ringlista)
  let files = Ringlista.ExcelFile; 
  var fromdata = new FormData();
  fromdata.append("Afid",Afid)
  fromdata.append("userid",userid)
  fromdata.append("Ringlista",JSON.stringify(Ringlista))
  files.forEach(file => fromdata.append('files[]', file));
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_IMPORT_RINGLIST});
    axios.post('kontos/RingList/ImportRL',
    fromdata,
     {
       body:{
        Afid:Afid,
        userid:userid,
        Ringlista:Ringlista,ipAdress
       },
       headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization':   `Bearer ${jwt}`
        }
     }
     ).then(({data}) => {
    console.log("ImportRinglist: ", data);
     if (data) {
      // dispatch({type: FETCH_ALL_CONTACT});
       dispatch({type: ON_IMPORT_RINGLIST, payload: data});
     } else {
       dispatch({type: ON_ERROR_IMPORT_RINGLIST, payload: data.message});
     }
     dispatch(RefreshUserInterface(userid))
   }).catch(function (error) {
     if (error.response.status === 401) {
          //place your reentry code
          dispatch({type: ON_OPEN_REFRESH_TOKEN});
         }
     dispatch({type: ON_ERROR_IMPORT_RINGLIST, payload: error.message});
      console.log("Error****:", error.message); 
     /*  if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
       */
   });
   
  } /* */
}
//GetRinglistEjRingtAntal
export const GetRinglistEjRingtAntal = (Afid,userid,Ringlistid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_FETCH_STATISTIC});
    axios.get('kontos/RingList/Statistic',
    { params:encrypt(JSON.stringify({
      userid:userid,
      Ringlistid:Ringlistid,
      Afid:Afid,ipAdress
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(data => {
      console.log("GetRinglistEjRingtAntal: ", data);
      if(data.data.success){
              let endata = decrypt(data.data.encryptedData,data.data.iv)
              console.log("GetRinglistEjRingtAntal1: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_FETCH_STATISTIC, payload: ndate.results});
            }
            else{
              let Data = isUndefined(data.data.error)?data.data:data.data.error
              let endata = decrypt(Data.encryptedData,Data.iv)
              console.log("GetRinglistEjRingtAntal2: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_ERROR_FETCH_STATISTIC, payload: ndate.error});
            }    
      
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_FETCH_STATISTIC, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
  }
}
//getStatisticRinglistor
export const getStatisticRinglistor = (Afid,userid,RinglistId,filter=[null,null]) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_FETCH_STATISTIC_KAMPANJER});
    axios.get('kontos/RingList/Statistics',
    { 
      params:encrypt(JSON.stringify({
        userid:userid,
        Afid:Afid,
        RinglistId:RinglistId,ipAdress,
        filter
      })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getStatisticRinglistor: ", data);
        if(data.data.success){
              let endata = decrypt(data.data.encryptedData,data.data.iv)
              console.log("getStatisticRinglistor1: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_FETCH_STATISTIC_KAMPANJER, payload: ndate.results});
            }
            else{
              let Data = isUndefined(data.data.error)?data.data:data.data.error
              let endata = decrypt(Data.encryptedData,Data.iv)
              console.log("getStatisticRinglistor2: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_ERROR_FETCH_STATISTIC_KAMPANJER, payload: ndate.error});
            }         
      
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_FETCH_STATISTIC_KAMPANJER, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
  }
}
 //GetRandomKundListByid

//removefromBLUSER
export const removefromBLUSER = (userid,Afid,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_KAMPANJ_ROMVE_BLIST});
     axios.put('kontos/Ringlist/Kund/RmFBlackList', {
      method: 'PUT',
      body: encrypt(JSON.stringify({
        userid:userid,
        Afid:Afid,
        Orgnr:Orgnr,ipAdress
      }))
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(data => {
      console.log("removefromBLUSER: ", data);
      if(data.data.success){
              let endata = decrypt(data.data.encryptedData,data.data.iv)
              console.log("removefromBLUSER1: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_KAMPANJ_KUND_ROMVE_BLIST, payload: ndate.results});
            }
            else{
              let Data = isUndefined(data.data.error)?data.data:data.data.error
              let endata = decrypt(Data.encryptedData,Data.iv)
              console.log("removefromBLUSER2: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_ERROR_KAMPANJ_KUND_ROMVE_BLIST, payload: ndate.error});
            }    
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_KAMPANJ_KUND_ROMVE_BLIST, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
   }
 } 
 //getRinglistByAfid
 export const getRinglistByAfid = (Afid,userid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_FETCH_GET_KAMPANJER});
    axios.get('kontos/RingList/get',
    { 
      params:encrypt(JSON.stringify({
        userid:userid,ipAdress,
        Afid:Afid,
      })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(data => {
      console.log("getRinglistByAfid: ", data);
      if(data.data.success){
              let endata = decrypt(data.data.encryptedData,data.data.iv)
              console.log("getRinglistByAfid1: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_FETCH_GET_KAMPANJER, payload: ndate.results});
            }
            else{
              let Data = isUndefined(data.data.error)?data.data:data.data.error
              let endata = decrypt(Data.encryptedData,Data.iv)
              console.log("getRinglistByAfid2: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_ERROR_FETCH_GET_KAMPANJER, payload: ndate.error});
            }  
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_FETCH_GET_KAMPANJER, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
  }
}
//getpersonligaaterkomstByID
export const getpersonligaaterkomstByID = (Afid,userid,MPerAterkomtid, IsFrom,Kampaj) =>{
  IsFrom=isUndefined(IsFrom)?0:IsFrom
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch,getState) => {
    const ipAdress='0.0.0.0'
    const {NextOrgnr} = getState().RingList;
    dispatch({type: ON_START_FETCH_KAMPANJ_KUND_PER});
    dispatch({type: SET_ZERO_EVENT});
    axios.get('kontos/RingList/getPerKund',
    { 
      params:encrypt(JSON.stringify({
        userid:userid,
        Afid:Afid,
        MPerAterkomtid:MPerAterkomtid,ipAdress,
      })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(data => {
      console.log("getpersonligaaterkomstByID: ", data);
      if(data.data.success){
         let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getpersonligaaterkomstByID1: ", endata);
          let ndate = JSON.parse(endata)
          if(!isEmpty(Kampaj)){
             dispatch({type: ON_FETCH_KAMPANJ_KUND_KOMPANJ_INNE, payload: ndate.results});
                      dispatch({type: ON_FETCH_HIT_COUNT, payload: {message: "getHitCount", HitCount: ndate.results.currentKampanj.hitcount}});          
                      if(isEmpty(NextOrgnr)){
                        let kampanj = {Rignlist:{id:Kampaj.Kampnaj.id}}
                        dispatch(getNextOrgnrBuffer(Afid,userid,kampanj,""))
                      }
          }
          dispatch({type: ON_FETCH_KAMPANJ_KUND_KOMPANJ_P, payload: ndate.results});
          if(parseInt(IsFrom) !== 3){
                    history.push({
                      pathname: parseInt(IsFrom) === 0?'/app/Dialervy2':'/app/Dialervy2',
                      state: { Ringlist: JSON.stringify(ndate.results.currentKampanj),
                      isnotis:1 }
            
                      });
                  }
      }
      else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
                let endata = decrypt(Data.encryptedData,Data.iv)
                console.log("getpersonligaaterkomstByID2: ", endata);
                let ndate = JSON.parse(endata)
                dispatch({type: ON_ERROR_FETCH_KAMPANJ_KUND, payload: ndate.error});
      }
      
      
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_FETCH_KAMPANJ_KUND, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
  }
}
//getBlackList
export const getBlackList = (Afid,userid,page,searchWord,BlackListTagId,filter,sortBy) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_FETCH_GET_BLACKLIST});
    axios.get('kontos/RingList/BlackList',
    { 
      params:encrypt(JSON.stringify({
        userid:userid,ipAdress,BlackListTagId,sortBy,
        Afid:Afid,
        filter:isUndefined(filter)?[]:filter,
        page:isUndefined(page)?0:page,
        searchWord:isUndefined(searchWord)?"":searchWord,
      })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(data => {
      console.log("getBlackList: ", data);
if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getBlackList1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_GET_BLACKLIST, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getBlackList2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_FETCH_GET_BLACKLIST, payload: ndate.error});
      }    
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_FETCH_GET_BLACKLIST, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
       } 
     });
  }
}
//onRemoveAllFromBlackList
export const onRemoveAllFromBlackList = ( Afid,userid,page,searchWord,BlackListTagId,filter,sortBy) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
   const ipAdress='0.0.0.0'
    dispatch({type: ON_START_DELETE_FROM_BL});
    axios.delete('kontos/RingList/blackList/List/deleteAll', {
     method: 'DELETE',
     data: encrypt(JSON.stringify({
       userid:userid,ipAdress,
       Afid:Afid,BlackListTagId,sortBy,
       filter:isUndefined(filter)?[]:filter,
       page:isUndefined(page)?0:page,
       searchWord:isUndefined(searchWord)?"":searchWord,
     })),
     headers: {
         'content-type': 'application/json',
         'Authorization':   `Bearer ${jwt}`
     }  
          
 }).then(data => {
     console.log("onRemoveAllFromBlackList: ", data);
 if(data.data.success){
      let endata = decrypt(data.data.encryptedData,data.data.iv)
      console.log("onRemoveAllFromBlackList1: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: ON_DELETE_FROM_BL, payload: ndate.results});
    }
    else{
      let Data = isUndefined(data.data.error)?data.data:data.data.error
      let endata = decrypt(Data.encryptedData,Data.iv)
      console.log("onRemoveAllFromBlackList2: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: ON_ERROR_DELETE_FROM_BL, payload: ndate.error});
    } 
      dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
       if (error.response.status === 401) {
          //place your reentry code
          dispatch({type: ON_OPEN_REFRESH_TOKEN});
         }
      dispatch({type: ON_ERROR_DELETE_FROM_BL, payload: error.message});
       console.log("Error****:", error.message); 
      if(error.message === "Network Error"){
         //reload and remove token 
         ////dispatch(userSignOut())
      } 
    });
  }
}
//onRemoveListFromBlackList
export const onRemoveListFromBlackList = ( Afid,userid,List,page,searchWord,BlackListTagId,filter,sortBy) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_DELETE_FROM_BL});
     axios.delete('kontos/RingList/blackList/List/delete', {
      method: 'DELETE',
      data: encrypt(JSON.stringify( {
        userid:userid,ipAdress,
        Afid:Afid,sortBy,BlackListTagId,
        List:List,
        filter:isUndefined(filter)?[]:filter,
        page:isUndefined(page)?0:page,
        searchWord:isUndefined(searchWord)?"":searchWord,
      })),
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }  
           
  }).then(data => {
      console.log("onRemoveListFromBlackList: ", data);
      if(data.data.success){
              let endata = decrypt(data.data.encryptedData,data.data.iv)
              console.log("onRemoveListFromBlackList1: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_DELETE_FROM_BL, payload: ndate.results});
            }
            else{
              let Data = isUndefined(data.data.error)?data.data:data.data.error
              let endata = decrypt(Data.encryptedData,Data.iv)
              console.log("onRemoveListFromBlackList2: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_ERROR_DELETE_FROM_BL, payload: ndate.error});
            }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_DELETE_FROM_BL, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
   }
 }
//onRemoveFromBlackList
export const onRemoveFromBlackList = ( Afid,userid,Orgnr,page,searchWord,BlackListTagId,filter,sortBy) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_DELETE_FROM_BL});
     axios.delete('kontos/RingList/blackList/delete', {
      method: 'DELETE',
      data: encrypt(JSON.stringify({
        userid:userid,ipAdress,sortBy,
        Afid:Afid,BlackListTagId,
        Orgnr:Orgnr,
        filter:isUndefined(filter)?0:filter,
        page:isUndefined(page)?0:page,
        searchWord:isUndefined(searchWord)?"":searchWord,
      })),
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }  
           
  }).then(data => {
      console.log("onRemoveFromBlackList: ", data);
       if(data.data.success){
              let endata = decrypt(data.data.encryptedData,data.data.iv)
              console.log("onRemoveFromBlackList1: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_DELETE_FROM_BL, payload: ndate.results});
            }
            else{
              let Data = isUndefined(data.data.error)?data.data:data.data.error
              let endata = decrypt(Data.encryptedData,Data.iv)
              console.log("onRemoveFromBlackList2: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_ERROR_DELETE_FROM_BL, payload: ndate.error});
            }
      
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_DELETE_FROM_BL, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
   }
 }
//getMinaPersonRecallList
export const getMinaPersonRecallList = (Afid,userid,page,searchWord,antaliSida,Sortby) =>{
  const jwt =  JSON.parse(localStorage.token);
  antaliSida= isUndefined(antaliSida)?25:antaliSida
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_FETCH_GET_PERSONAL_LIST});
    axios.get('kontos/RingList/MinaPerson',
    { 
      params:encrypt(JSON.stringify({
        userid:userid,ipAdress,
        Afid:Afid,sortBy:Sortby,
        page:isUndefined(page)?0:page,
        searchWord:isUndefined(searchWord)?"":searchWord,antaliSida
      })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getMinaPersonRecallList: ", data);
      if(data.data.success){
              let endata = decrypt(data.data.encryptedData,data.data.iv)
              console.log("getMinaPersonRecallList1: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_FETCH_GET_PERSONAL_LIST, payload: ndate.results});
            }
            else{
              let Data = isUndefined(data.data.error)?data.data:data.data.error
              let endata = decrypt(Data.encryptedData,Data.iv)
              console.log("getMinaPersonRecallList2: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_ERROR_FETCH_GET_PERSONAL_LIST, payload: ndate.error});
            }   

       
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_FETCH_GET_PERSONAL_LIST, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
       } 
     });
  }
}
//onRemoveFromPersonRecall
export const onRemoveFromPersonRecall = ( Afid,userid,Orgnr,page,searchWord,antaliSida,Sortby) =>{
  const jwt =  JSON.parse(localStorage.token);
  antaliSida= isUndefined(antaliSida)?25:antaliSida
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_DELETE_FROM_PERSONAL_LIST});
     axios.delete('kontos/RingList/MinaPerson/delete', {
      method: 'DELETE',
      data:encrypt(JSON.stringify({
        userid:userid,ipAdress,
        Afid:Afid,sortBy:Sortby,
        Orgnr:Orgnr,
        page:isUndefined(page)?0:page,
        searchWord:isUndefined(searchWord)?"":searchWord,antaliSida
      })),
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }  
           
  }).then(data => {
      console.log("onRemoveFromPersonRecall: ", data);
       if(data.data.success){
              let endata = decrypt(data.data.encryptedData,data.data.iv)
              console.log("onRemoveFromPersonRecall1: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_DELETE_FROM_PERSONAL_LIST, payload: ndate.results});
            }
            else{
              let Data = isUndefined(data.data.error)?data.data:data.data.error
              let endata = decrypt(Data.encryptedData,Data.iv)
              console.log("onRemoveFromPersonRecall2: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_ERROR_DELETE_FROM_PERSONAL_LIST, payload: ndate.error});
            } 
    
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_DELETE_FROM_PERSONAL_LIST, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
   }
 }
//getMinaBlackList
export const getMinaBlackList = ( Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_GET_BLACKLIST_LIST});
    axios.get('kontos/RingList/BlackList/get',
    { 
      params:encrypt(JSON.stringify({
        Afid:Afid,
      })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getMinaPersonRecallList: ", data);
      if(data.data.success){
              let endata = decrypt(data.data.encryptedData,data.data.iv)
              console.log("getMinaPersonRecallList1: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_FETCH_GET_BLACKLIST_LIST, payload: ndate.results});
            }
            else{
              let Data = isUndefined(data.data.error)?data.data:data.data.error
              let endata = decrypt(Data.encryptedData,Data.iv)
              console.log("getMinaPersonRecallList2: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_ERROR_FETCH_GET_BLACKLIST_LIST, payload: ndate.error});
            }       

     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_FETCH_GET_BLACKLIST_LIST, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
       } 
     });
  }
}
//SetNullMoteDialer
export const SetNullMoteDialer=()=>{
  return async (dispatch) => {
    dispatch({type: ON_SET_NULL_MESSAGE_DIALER});
  }
}
export const onCloseDialerToaster=()=>{
  return async (dispatch) => {
    dispatch({type: ON_SET_NULL_EVENT_DIALER});
  }
}
export const setFalseHasNoAccess=()=>{
  return async (dispatch) => {
    dispatch({type: ON_SET_NULL_NOACCESS_DIALER});
  }
}
//getThisKampnajKundItemNext
export const getThisKampnajKundItemNext = (Afid,userid,Orgnr,ListID,filter) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_FETCH_GET_NEXT_KUND_1});
    axios.get('kontos/RingList/getNextKund',
    { params:encrypt(JSON.stringify({
      userid:userid,ipAdress,
      Afid:Afid,
      ListID:ListID,
      Orgnr:Orgnr,filter
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {      
      console.log("getNextKund: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getNextKund1: ", endata);
        let ndate = JSON.parse(endata)
        if(isUndefined(ndate.results.noAccess)){
          dispatch({type: ON_FETCH_GET_NEXT_KUND_1, payload: ndate.results});  
         }
         else{
           let NextOrgnr =ndate.results.NextOrgnr
           if(!isEmpty(String(NextOrgnr))){
             dispatch(getThisKampnajKundItemNext(Afid,userid,NextOrgnr,ListID,filter))
           }
         }      
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getNextKund2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_FETCH_GET_NEXT_KUND, payload: ndate.error});
      }
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_FETCH_GET_NEXT_KUND, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
  }
}
//getThisKampnajKundItemPrev
export const getThisKampnajKundItemPrev = (Afid,userid,Orgnr,ListID,filter) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_FETCH_GET_NEXT_KUND_2});
    axios.get('kontos/RingList/getPrevKund',
    { params:encrypt(JSON.stringify({
      userid:userid,ipAdress,
      Afid:Afid,
      ListID:ListID,
      Orgnr:Orgnr,filter
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getNextKund: ", data);
      if(data.data.success){
              let endata = decrypt(data.data.encryptedData,data.data.iv)
              console.log("getNextKund1: ", endata);
              let ndate = JSON.parse(endata)
              if(isUndefined(ndate.results.noAccess)){
      dispatch({type: ON_FETCH_GET_NEXT_KUND_2, payload: ndate.results});
              } else{
                let NextOrgnr =ndate.results.NextOrgnr
                if(!isEmpty(String(NextOrgnr))){
                  dispatch(getThisKampnajKundItemPrev(Afid,userid,NextOrgnr,ListID,filter))
                }
              }           
            }
            else{
              let Data = isUndefined(data.data.error)?data.data:data.data.error
              let endata = decrypt(Data.encryptedData,Data.iv)
              console.log("getNextKund2: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_ERROR_FETCH_GET_NEXT_KUND, payload: ndate.error});
            }
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_FETCH_GET_NEXT_KUND, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
  }
}
//onAddnewLineToDialerKundData
export const onAddnewLineToDialerKundData = (Afid,userid,Orgnr,ListId,newLine,type) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_ADD_KD_DIALER_NEWLINE});
     axios.put('kontos/Ringlist/Kund/Kunddata/line/new', {
      method: 'PUT',
      body: encrypt(JSON.stringify( {
        userid:userid,
        Afid:Afid,
        Orgnr:Orgnr,
        ListId:ListId,
        newLine:newLine,
        type:type,
        ipAdress
      }))
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then( data => {
      console.log("onAddnewLineToDialerKundData: ", data);
      if(data.data.success){
              let endata = decrypt(data.data.encryptedData,data.data.iv)
              console.log("GetHitCountRL1: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_ADD_KD_DIALER_NEWLINE, payload: ndate.results});
            }
            else{
              let Data = isUndefined(data.data.error)?data.data:data.data.error
              let endata = decrypt(Data.encryptedData,Data.iv)
              console.log("GetHitCountRL2: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_ERROR_ADD_KD_DIALER_NEWLINE, payload: ndate.error});
            } 

       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_ADD_KD_DIALER_NEWLINE, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
       } 
     });
   }
 } 
//onGetCurrentKunddataByOrgnr
export const onGetCurrentKunddataByOrgnr = (Afid,userid,Orgnr,ListID,type) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_FETCH_GET_KD_DIALER});
    axios.get('kontos/RingList/Kund/Kunddata/get',
    { params:encrypt(JSON.stringify({
      userid:userid,ipAdress,
      Afid:Afid,
      ListID:ListID,
      Orgnr:Orgnr,
      type:type,
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(data => {
      console.log("getNextKund: ", data);
        if(data.data.success){
              let endata = decrypt(data.data.encryptedData,data.data.iv)
              console.log("getNextKund1: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_FETCH_GET_KD_DIALER, payload: ndate.results});
            }
            else{
              let Data = isUndefined(data.data.error)?data.data:data.data.error
              let endata = decrypt(Data.encryptedData,Data.iv)
              console.log("getNextKund2: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_ERROR_FETCH_GET_KD_DIALER, payload: ndate.error});
            }  
   
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_FETCH_GET_KD_DIALER, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
  }
}
//onupdateThisRowDialerKD
export const onupdateThisRowDialerKD = (Afid,userid,Orgnr,ListId,newLine,LineId) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_ADD_KD_DIALER_NEWLINE});
     axios.put('kontos/Ringlist/Kund/Kunddata/line/update', {
      method: 'PUT',
      body: encrypt(JSON.stringify({
        userid:userid,
        Afid:Afid,
        Orgnr:Orgnr,
        ListId:ListId,
        newLine:newLine,
        LineId:LineId,
        ipAdress
      }))
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(data => {
      console.log("onAddnewLineToDialerKundData: ", data);
       if(data.data.success){
              let endata = decrypt(data.data.encryptedData,data.data.iv)
              console.log("onAddnewLineToDialerKundData1: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_UPPDATE_KD_DIALER_NEWLINE, payload: ndate.results});
            }
            else{
              let Data = isUndefined(data.data.error)?data.data:data.data.error
              let endata = decrypt(Data.encryptedData,Data.iv)
              console.log("onAddnewLineToDialerKundData2: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_ERROR_UPPDATE_KD_DIALER_NEWLINE, payload: ndate.error});
            }     

       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_UPPDATE_KD_DIALER_NEWLINE, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
       } 
     });
   }
 } 
//onDeletRowDialerKdbyType
export const onDeletRowDialerKdbyType = (Afid,userid,Orgnr,type,DelRad) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_ADD_KD_DIALER_NEWLINE});
     axios.delete('kontos/Ringlist/Kund/Kunddata/line/delete', {
      method: 'DELETE',
      data: encrypt(JSON.stringify({
        userid:userid,ipAdress,
        Afid:Afid,
        Orgnr:Orgnr,
        type:type,
        DelRad:DelRad,
      })),
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }  
           
  }).then( data => {
      console.log("onRemoveFromPersonRecall: ", data);
      if(data.data.success){
              let endata = decrypt(data.data.encryptedData,data.data.iv)
              console.log("onDeletRowDialerKdbyType1: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_DELETE_KD_DIALER_NEWLINE, payload: ndate.results});
            }
            else{
              let Data = isUndefined(data.data.error)?data.data:data.data.error
              let endata = decrypt(Data.encryptedData,Data.iv)
              console.log("onDeletRowDialerKdbyType2: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_ERROR_DELETE_KD_DIALER_NEWLINE, payload: ndate.error});
            }   
     
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_DELETE_KD_DIALER_NEWLINE, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
   }
 }
//getDialerRapport
export const getDialerRapport = (Afid,userid,Kampanj,sendTo) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch,getState) => {
    const {IpAdress} = getState().auth;
    dispatch({type: ON_START_FETCH_GET_RAPPORT_DIALER});
    axios.get('kontos/RingList/KD/Rapport',
    { params:encrypt(JSON.stringify({
      userid:userid,
      IpAdress,
      Afid:Afid,
      Kampanj:Kampanj,
      sendTo
    })), 
    responseType: 'arraybuffer' ,
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     )
     .then((resp) => {
      if(resp.status === 200){
      console.log(resp)
      try{
      const dirtyFileName = resp.headers['content-disposition'];
      const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
      var  fileName = dirtyFileName.match(regex)[3];
      var blob = new Blob([resp.data], 
       { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      );
      fileSaver.saveAs(blob, fileName);
      }catch(error){
        console.log(error,"DDDDD")
        dispatch({type: ON_ERROR_FETCH_GET_RAPPORT_DIALER})
      }
    }
     // dispatch({type: ON_FETCH_UTOKNING_RAPPORT})
     }).catch(function (error) {
     dispatch({type: ON_ERROR_FETCH_GET_RAPPORT_DIALER})
     console.log("Error****:", error.message); 
     });
  }
}
//getDialerRapport1
export const getDialerRapport1 = (Afid,userid,Kampanj,sendTo) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch,getState) => {
    const {IpAdress} = getState().auth;
    dispatch({type: ON_START_FETCH_GET_RAPPORT_DIALER});
    axios.get('kontos/RingList/Rapport',
    { params:encrypt(JSON.stringify({
      userid:userid,
      IpAdress,
      Afid:Afid,
      Kampanj:Kampanj,
      sendTo
    })), 
    responseType: 'arraybuffer' ,
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     )
     .then((resp) => {
      console.log(resp)
      try{
      const dirtyFileName = resp.headers['content-disposition'];
      const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
      var  fileName = dirtyFileName.match(regex)[3];
      var blob = new Blob([resp.data], 
       { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      );
      fileSaver.saveAs(blob, fileName);
      }catch(error){
        console.log(error,"DDDDD")
        dispatch({type: ON_ERROR_FETCH_GET_RAPPORT_DIALER})
      }
     // dispatch({type: ON_FETCH_UTOKNING_RAPPORT})
     }).catch(function (error) {
     dispatch({type: ON_ERROR_FETCH_GET_RAPPORT_DIALER})
     console.log("Error****:", error.message); 
     });
  }
}
//getAvtalsTidKundList
export const getAvtalsTidKundList = (Afid,userid,page,SearchWord,sortBy) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch,getState) => {
    const {IpAdress} = getState().auth;
    dispatch({type: ON_START_GET_DIALER_AVTALSTID_LIST});
    axios.get('kontos/RingList/Avtalstid/list',
    { params:encrypt(JSON.stringify({
      userid:userid,IpAdress,
      Afid:Afid,sortBy,
      page,SearchWord
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getNextKund: ", data);
      if(data.data.success){
              let endata = decrypt(data.data.encryptedData,data.data.iv)
              console.log("getAvtalsTidKundList1: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_GET_DIALER_AVTALSTID_LIST, payload: ndate.results});
            }
            else{
              let Data = isUndefined(data.data.error)?data.data:data.data.error
              let endata = decrypt(Data.encryptedData,Data.iv)
              console.log("getAvtalsTidKundList2: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_ERROR_GET_DIALER_AVTALSTID_LIST, payload: ndate.error});
            }
     
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_GET_DIALER_AVTALSTID_LIST, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
  }
}
//getKommunLanList
export const getKommunLanList = (Lan) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch,getState) => {
    const {IpAdress} = getState().auth;
    dispatch({type: ON_START_GET_DIALER_KOMMUN_LIST});
    axios.get('kontos/RingList/Kummon/list',
    { params:encrypt(JSON.stringify({
      Lan
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getKommunLanList: ", data);
      if(data.data.success){
              let endata = decrypt(data.data.encryptedData,data.data.iv)
              console.log("getKommunLanList1: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_GET_DIALER_KOMMUN_LIST, payload: ndate.results});
            }
            else{
              let Data = isUndefined(data.data.error)?data.data:data.data.error
              let endata = decrypt(Data.encryptedData,Data.iv)
              console.log("getKommunLanList2: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_ERROR_GET_DIALER_KOMMUN_LIST, payload: ndate.error});
            }
     
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_DIALER_KOMMUN_LIST, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
  }
}
//onUpdateThisDialerKommentar
export const onUpdateThisDialerKommentar = (Afid,userid,Orgnr,item) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_UPPDATE_DIALER_KOMMMENTAR});
     axios.put('kontos/Ringlist/Kund/logg/update', {
      method: 'PUT',
      body: encrypt(JSON.stringify( {
        userid:userid,
        Afid:Afid,
        Orgnr:Orgnr,
        item:item,
        ipAdress
      }))
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then( data => {
      console.log("onAddnewLineToDialerKundData: ", data);
       if(data.data.success){
              let endata = decrypt(data.data.encryptedData,data.data.iv)
              console.log("onAddnewLineToDialerKundData1: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_UPPDATE_DIALER_KOMMMENTAR, payload: ndate.results});
            }
            else{
              let Data = isUndefined(data.data.error)?data.data:data.data.error
              let endata = decrypt(Data.encryptedData,Data.iv)
              console.log("onAddnewLineToDialerKundData2: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_ERROR_UPPDATE_DIALER_KOMMMENTAR, payload: ndate.error});
            }
      
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      if (error.response.status === 401) {
        //place your reentry code
        dispatch({type: ON_OPEN_REFRESH_TOKEN});
       }
       dispatch({type: ON_ERROR_UPPDATE_DIALER_KOMMMENTAR, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
       } 
     });
   }
 } 
//getUserDialerHistory
export const getUserDialerHistory = (Afid,userid,page=0,callbackFunc) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch,getState) => {
    const {IpAdress} = getState().auth;
    dispatch({type: ON_START_GET_DIALER_USER_HISTORY});
    axios.get('kontos/RingList/user/History',
    { params:encrypt(JSON.stringify( {
      Afid,userid,page
    })), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getKommunLanList: ", data);
       if(data.data.success){
              let endata = decrypt(data.data.encryptedData,data.data.iv)
              console.log("onAddnewLineToDialerKundData1: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_GET_DIALER_USER_HISTORY, payload: ndate.results});
              callbackFunc(ndate.results)
            }
            else{
              let Data = isUndefined(data.data.error)?data.data:data.data.error
              let endata = decrypt(Data.encryptedData,Data.iv)
              console.log("onAddnewLineToDialerKundData2: ", endata);
              let ndate = JSON.parse(endata)
              dispatch({type: ON_ERROR_GET_DIALER_USER_HISTORY, payload: ndate.error});
            }
      
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_DIALER_USER_HISTORY, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          ////dispatch(userSignOut())
       } 
     });
  }
}

